import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

export default function DocumentcloudBlock({ html }) {
  return parse(DOMPurify.sanitize(html, { ALLOWED_TAGS: ['iframe'] }));
}

DocumentcloudBlock.propTypes = {
  html: PropTypes.string.isRequired,
};
